const KNOWN_INITIALISMS = /^(c[teiofd]o|vp|svp|evp|pm|pmo|em|hr|qa|ux)$/i;

// Adjacent-key runs people type to get past a required field.
const KEYBOARD_MASH =
  /^(a?sdf|asdfg|qwe|qwer|qwerty|zxc|zxcv|qaz|wsx|jkl|hjkl|lkj|fgh|ghj|poi|mnb|test|foo|bar|baz)+$/i;

const hasVowel = (word: string) => /[aeiouy]/i.test(word);
const isSingleRepeatedCharacter = (word: string) => /^(.)\1+$/.test(word);
const hasAnyLetter = (word: string) => /\p{L}/u.test(word);

// Shared by SIR (which pays for the interpretation call) and the frontend (which decides whether
// to make it) — a single check so the two sides can't independently drift on what counts as
// plausible. Deliberately permissive: a false accept wastes one model call; a false reject
// silently downgrades a real reader's lens with no way for them to notice.
export const isPlausibleTitle = (title: string): boolean => {
  const trimmed = title.trim();
  if (trimmed.length < 2) return false;

  return trimmed
    .split(' ')
    .filter(Boolean)
    .some((word) => {
      const letters = word.replace(/[^a-z]/gi, '');
      // No ASCII letters: punctuation-only rejects; a non-Latin script accepts, per the "errs
      // toward accepting" rule above.
      if (!letters) return hasAnyLetter(word);
      if (KNOWN_INITIALISMS.test(letters)) return true;

      return (
        hasVowel(letters) && !isSingleRepeatedCharacter(letters) && !KEYBOARD_MASH.test(letters)
      );
    });
};
